export const SPONSORED_TILE_TOP_DESTINATION_IDS: ReadonlySet<string> = new Set([
  'le_64930b7151b6bc3e289f37d5da62ac9f', // Bali
  'le_72b32a1f754ba1c09b3695e0cb6cde7f', // Fiji
  'le_8f85517967795eeef66c225f7883bdcb', // Thailand
  'le_2723d092b63885e0d7c260cc007e8b9d', // Maldives
  'le_bac732346917b0a1231354ef55faf00a', // Gold Coast
  'le_bd4c9ab730f5513206b999ec0d90d1fb', // Singapore
  'le_d47bb339212ddfab0fadd99d492a5fc3', // Phuket Province
  'le_d3d9446802a44259755d38e6d163e820', // Australia
  'le_a597e50502f5ff68e3e25b9114205d4a', // Vietnam
  'le_a55472983efa2e239b315de91576d1d3', // Nusa Dua
  'le_790d9f1f52e10ef90ede8efcf7f3c078', // Seminyak
  'le_3d3621cee6f49e93a34f3f0f654ab41a', // Queensland
  'le_8337a7365ec44f3d65434a5ea4d73d17', // New South Wales
  'le_979d472a84804b9f647bc185a877a8b5', // Hawaii
  'le_7f7ed8ecfca9e17696ff654508efd86a', // Ubud
  'le_ff7aa1f9b4062bfee0f99a0453506f1b', // Bangkok
  'le_58a2fc6ed39fd083f55d4182bf88826d', // Vanuatu
  'le_a3c65c2974270fd093ee8a9bf8ae7d0b', // Malaysia
  'le_f3ad1c493ba61ad63bb43d6947f42d95', // Khao Lak
  'le_edd47ba7fa1bbff38973841c9cd0733c', // Tasmania
  'le_f243f5a39d3b7ef531788ff07ea1ca58', // Kuala Lumpur
  'le_43ec517d68b6edd3015b3edc9a11367b', // Indonesia
  'le_757b505cfd34c64c85ca5b5690ee5293', // United States of America
  'le_8a146f1a3da4700cbf03cdc55e2daae6', // Honolulu
  'le_808ace92242c99f7e4aa4672c45e2138', // Jimbaran
  'le_ce393994e8cf430867408678d1a5a9c8', // Singapore (city)
  'le_c434daa77ef5bff49159bb7305963f01', // Kata
  'le_bb5ebfe18035bce236fcddd3717ecbf1', // Western Division
  'le_3b71787064fdfa34ec883e95c0b3f97c', // Phang Nga Province
  'le_bcb61cc59b9cc227748e9b437179d3b0', // South East Asia
  'le_6b3bbd969f79a2225979a469afc9017e', // Surat Thani Province
  'le_76a873c26fe13fb4bbe0def50cd27908', // Central Atolls
  'le_0d7ff7182f6ae062c10c3f128960bd6c', // Pecatu
  'le_189c76ce42e2c4f665a469fde5adfc12', // Bangkok Province
  'le_6bfd7a723e671ca2c8bb5e22a875e4ad', // Langkawi
])
